import React, { useState, useMemo } from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';
import { TaskSelectorProps } from '../types';
import { styles } from '../../MilestoneModal.styles';
import { TaskList } from '../TaskList';
import { EmptyState } from '../EmptyState';

// Inline styles to resolve import error
const getTaskSelectorStyles = (): SxProps<Theme> => ({
     display: 'flex',
     alignItems: 'flex-start',
     gap: 2,
});



export const TaskSelector: React.FC<TaskSelectorProps> = ({
     selectedTasks,
     availableTasks,
     selectedMilestone,
     onTasksChange,
     currentMilestones = [],
     onDeleteTask,
     onRenameTask,
     onReorderTasks,
     isAddingMilestone = false,
     allTaskNames,
     allMilestones,
}) => {
     // State for inline editing
     const [editingTaskId, setEditingTaskId] = useState<string | null>(null);

     // Filter tasks for the selected milestone and sort by taskOrder
     const milestoneTasks = useMemo(() => {
          if (isAddingMilestone) {
               // When adding a new milestone, show all available tasks
               return availableTasks.map((task: any) => ({
                    taskCode: task.taskCode,
                    taskName: task.taskName,
                    taskOrder: task.taskOrder || 0,
                    isApplicable: false,
                    id: `new_${task.taskCode}`,
                    isDefault: null,
                    mileStoneCode: 'NEW_MILESTONE'
               })).sort((a: any, b: any) => a.taskOrder - b.taskOrder);
          }

          const filtered = currentMilestones
               .filter((milestone: any) => milestone.mileStoneName === selectedMilestone)
               .map((milestone: any) => ({
                    taskCode: milestone.taskCode,
                    taskName: milestone.taskName,
                    taskOrder: milestone.taskOrder || 0,
                    isApplicable: milestone.status,
                    id: milestone.id,
                    isDefault: milestone.isDefault,
                    mileStoneCode: milestone.mileStoneCode
               }))
               .sort((a: any, b: any) => a.taskOrder - b.taskOrder);

          return filtered;
     }, [currentMilestones, selectedMilestone, isAddingMilestone, availableTasks]);

     const handleStartEdit = (task: any) => {
          setEditingTaskId(task.id);
     };

     const handleCancelEdit = () => {
          setEditingTaskId(null);
     };

     const handleRenameTask = (taskId: string, newName: string) => {
          if (onRenameTask) {
               onRenameTask(taskId, newName);
          }
          setEditingTaskId(null);
     };

     if (!selectedMilestone && !isAddingMilestone) {
          return <EmptyState />;
     }

     return (
          <Box>
               <Typography variant="body1" sx={styles.sectionTitle}>
                    Tasks for: {selectedMilestone}
               </Typography>
               <Box sx={getTaskSelectorStyles()}>
                    <TaskList
                         tasks={milestoneTasks}
                         selectedTasks={selectedTasks}
                         selectedMilestone={selectedMilestone}
                         editingTaskId={editingTaskId}
                         onTasksChange={onTasksChange}
                         onDeleteTask={onDeleteTask}
                         onRenameTask={handleRenameTask}
                         // onReorderTasks={onReorderTasks}
                         onStartEdit={handleStartEdit}
                         onCancelEdit={handleCancelEdit}
                         allTaskNames={allTaskNames}
                         currentMilestones={allMilestones}
                    />
               </Box>
          </Box>
     );
}; 